import { useQuery } from "react-query";
import { http } from "src/api/http";
import { TotalFans } from "./models";
import WidgetCard from "@arelia-components/ui-atoms/WidgetCard";
import { Typography } from "@mui/material";

export default function FansDashboardContainer() {
  const { data, isLoading, isError } = useQuery<TotalFans>({
    queryKey: ["total-fans-count"],
    queryFn: () => http('/api/my-fans/count'),
  });

  return (
    <WidgetCard
      widgetId={"TOTAL_FANS_COUNT"}
      title={"Total Fans"}
      loading={isLoading}
      error={isError}
      navigateLink="/my-fans/list"
      footerText="View all Fans"
      disableFavorite={false}
    >
      <Typography variant="h2">{data?.totalFansCount} fans</Typography>
    </WidgetCard>
  );
}
